import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const GROUP_COURSE = 'group_course'
const STUDENTS = 'students'

/**
 * Form model
 */
const formModel = () => {
  return {
    [GROUP_COURSE]: {
      label: `${t('common.group-course')}`,
      name: GROUP_COURSE,
      required: true,
    },
    [STUDENTS]: {
      label: `${t('meetings.participant')}`,
      name: STUDENTS,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GROUP_COURSE]: null,
  [STUDENTS]: [
    {
      email: '',
      first_name: '',
      last_name: '',
    },
  ],
}

/**
 * Form data validation
 */
export const validationSchema = (userRole: string) =>
  yup.object().shape({
    [GROUP_COURSE]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [STUDENTS]: yup
      .array()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
